import { utils } from 'ethers'

export const LENDER_VERIFIER_ABI = ['function isAllowed(address lender) view returns (bool)'] as const

export const LENDER_VERIFIER_INTERFACE = new utils.Interface(LENDER_VERIFIER_ABI)
